/**
 * @file 头部导航
 * @author chenyuyang
 */
import React from 'react';

import './style.less';
const CustomButton = (props: any) => {
    const {children, className, ...attrs} = props;
    return (<button
        className={'comp-button ' + (className || '')}
        {...attrs}
    >
        {children}
    </button>);
};
export default CustomButton;
